module.exports = "<div class=\"content-page\">\n<p>operation works!</p>\n</div>\n"